
import {
  FETCH_PARK_DETAILS_REQUEST,
  FETCH_PARK_DETAILS_SUCCESS,
  FETCH_PARK_DETAILS_FAILURE,
  UPDATE_PARK_DETAILS_REQUEST,
  UPDATE_PARK_DETAILS_SUCCESS,
  UPDATE_PARK_DETAILS_FAILURE,
} from "../actions/parkdetailsActions";

const initialState = {
  parkDetails: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalItems: 0,
    limit: 10,
  },
  loading: false,
  error: null,
};

export default function parkDetailsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_PARK_DETAILS_REQUEST:
    case UPDATE_PARK_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_PARK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        parkDetails: action.payload.data,
        pagination: action.payload.pagination,
      };

    case UPDATE_PARK_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        parkDetails: state.parkDetails.map((p) =>
          p.id === action.payload.id ? action.payload : p
        ),
      };

    case FETCH_PARK_DETAILS_FAILURE:
    case UPDATE_PARK_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
